import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

const NewItems = (): JSX.Element => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12}>
          new items
        </Grid>
      </Grid>
    </Container>
  )
}

export default NewItems
